var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecoverPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5322_154866)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.2852,
    y: 35.7413,
    width: 26.6319,
    height: 19.2888,
    stroke: "#949494",
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0898 29.8217C31.0898 24.5687 35.3482 20.3103 40.6012 20.3103V20.3103C45.8542 20.3103 50.1126 24.5687 50.1126 29.8217V35.7413H31.0898V29.8217Z",
    stroke: "#949494",
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6015 47.3145C41.6521 47.3145 42.5038 46.451 42.5038 45.3857C42.5038 44.3204 41.6521 43.4568 40.6015 43.4568C39.5509 43.4568 38.6992 44.3204 38.6992 45.3857C38.6992 46.451 39.5509 47.3145 40.6015 47.3145Z",
    stroke: "#949494",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3068 10.8334L58.0546 11.2675L58.3068 10.8334ZM60.4963 12.5518C60.7618 12.4819 60.9215 12.2071 60.8529 11.938L59.7354 7.55286C59.6668 7.28377 59.396 7.12231 59.1305 7.19224C58.8649 7.26217 58.7053 7.537 58.7738 7.80609L59.7672 11.704L55.9209 12.7169C55.6553 12.7868 55.4957 13.0617 55.5643 13.3308C55.6328 13.5999 55.9037 13.7613 56.1692 13.6914L60.4963 12.5518ZM58.0546 11.2675L60.1199 12.4986L60.6243 11.6305L58.559 10.3994L58.0546 11.2675ZM6.66584 44.1073C4.32298 16.0889 34.1584 -2.97733 58.0546 11.2675L58.559 10.3994C33.9681 -4.25956 3.2653 15.3609 5.67627 44.1938L6.66584 44.1073Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1201 70.1349L23.3792 69.705L23.1201 70.1349ZM20.9586 68.3816C20.6919 68.4473 20.5279 68.7195 20.5921 68.9897L21.639 73.3922C21.7033 73.6623 21.9715 73.8281 22.2381 73.7624C22.5047 73.6968 22.6688 73.4246 22.6045 73.1544L21.674 69.2411L25.536 68.29C25.8026 68.2244 25.9667 67.9521 25.9024 67.682C25.8382 67.4118 25.57 67.2461 25.3034 67.3117L20.9586 68.3816ZM23.3792 69.705L21.334 68.4408L20.8158 69.3007L22.861 70.5649L23.3792 69.705ZM75.2888 37.6947C77.1814 65.7471 47.0436 84.3317 23.3792 69.705L22.861 70.5649C47.2133 85.6169 78.2273 66.492 76.2796 37.624L75.2888 37.6947Z",
    fill: "#949494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5322_154866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoverPassword);
export default __webpack_public_path__ + "static/media/recover-password.ef87235db71bc329e363b7635793a58a.svg";
export { ForwardRef as ReactComponent };